const ROMAN: Array<[number, string]> = [
  [10, 'X'],
  [9, 'IX'],
  [5, 'V'],
  [4, 'IV'],
  [1, 'I'],
];

/**
 * USML category in Roman numerals, for display only: "8" or "08" → "VIII",
 * "11(a)" → "XI(a)". Values already in Roman numerals, or outside I–XXI, are
 * shown as filed. Stored and exported values keep the numeric code AES files.
 * Mirrors usmlDisplay in the analyzer service's utils/AesAnalyzer/rules.ts
 * (biteservices).
 */
export function usmlDisplay(value?: string | null): string {
  const s = (value || '').trim();
  const m = s.match(/^0*(\d{1,2})(.*)$/);
  if (!m) return s.toUpperCase();
  let n = Number(m[1]);
  if (n < 1 || n > 21) return s;
  let out = '';
  ROMAN.forEach(([v, numeral]) => {
    while (n >= v) {
      out += numeral;
      n -= v;
    }
  });
  return out + m[2];
}

const YES = ['Y', 'YES', 'TRUE', '1', 'T'];

/** Routed Transaction Indicator as Y / N, or null when the upload has none. */
export function routedFlag(
  fields: Record<string, string> | undefined,
  hasColumn: boolean,
): 'Y' | 'N' | null {
  if (!hasColumn) return null;
  return YES.includes(
    String(fields?.routed || '')
      .trim()
      .toUpperCase(),
  )
    ? 'Y'
    : 'N';
}
